<template>
  <GlobalBackground />
  <div class="page">
    <router-view />
  </div>
  
</template>

<script setup lang="ts">
import GlobalBackground from './components/GlobalBackground.vue'
</script>

<style>
:root {
  color-scheme: dark;
  --bg: #05060a;
  --fg: #e8e8f0;
  --muted: #b8b8c7;
  --accent: #7b5cff;
  --card: rgba(255,255,255,0.03);
  --border: rgba(255,255,255,0.08);
}
html, body, #app { height: 100%; margin: 0; }
body {
  background: radial-gradient(120% 120% at 10% 0%, #0a0b14 0%, transparent 60%),
              radial-gradient(120% 120% at 90% 10%, #0c0d18 0%, transparent 60%),
              var(--bg);
  color: var(--fg);
  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, Helvetica Neue, Arial, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden; /* Disable page scrolling - single screen HUD */
}
h1, h2, h3, p, .page, main, section { position: relative; z-index: 1; }
.page { isolation: isolate; }
h1, h2, h3 { letter-spacing: 0.01em; }
p { color: var(--muted); }
::selection { background: color-mix(in oklab, var(--accent) 30%, white); color: #0b0b12; }
</style>
